module.exports = __webpack_public_path__ + "img/cnh.53e3ddfc.png";